import React from "react"
import { Field, ErrorMessage, getIn } from "formik"
import ErrorPopUp from '../../Shared/ErrorPopUp'
import QtyInput from '../../Shared/QtyInput'
import MeasurementTypeDoubleBox from '../../Shared/MeasurementTypeDoubleBox'

export default ({ touched, errors, setFieldValue, values, handleBlur }) => (
  <>
    <div className="row display-flex">
      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <fieldset className="fieldset">
          <legend>مواد اولیه</legend>
          <table className="table validator-table" style={{ marginBottom: 5 }}>
            <thead>
              <tr>
                <th className="text-center">ردیف</th>
                <th className="text-center">دسته بندی</th>
                <th className="text-center">برند</th>
                <th className="text-center">نام کالا</th>
                {/* <th className="text-center">مقدار موجود</th> */}
                {values.unitTaskStatus === 2 ?
                  <th className="text-center">مقدار استفاده شده سالم</th>
                  : ''}
                {values.unitTaskStatus === 2 ?
                  <th className="text-center">ضایعات</th>
                  : ''}
                {/* <th className="text-center">واحد شمارش</th> */}
              </tr>
            </thead>
            <tbody>
              {values.items && values.items.map((item, index) => (
                <tr key={"p-" + index}>
                  <td>{index + 1}</td>
                  <td>
                    {values.items[index].product && values.items[index].product.category.name}
                  </td>
                  <td>
                    {values.items[index].product && values.items[index].product.brand.name}
                  </td>
                  <td>
                    {values.items[index].product && values.items[index].product.name}
                  </td>
                  {/* <td>
                    {values.items[index].unitProductQuantity ? (values.items[index].unitProductQuantity + (' ' + values.items[index].product ? ' (' + measurementTypes.filter(el => el.value === values.items[index].product.measurementType)[0].label + ')' : '')) : ''}
                  </td> */}
                  {values.unitTaskStatus === 2 ?
                    <td>
                      {values.items[index].product !== undefined &&
                        <QtyInput
                          disabled={values.items[index].product && values.items[index].product.conversionUnit && values.items[index].product.measurementType !== values.items[index].product.subMeasurementType ? true : false}
                          className="text-input"
                          measurementType={values.items[index].product ? values.items[index].product.measurementType : undefined}
                          subMeasurementType={values.items[index].product ? values.items[index].product.subMeasurementType : undefined}
                          conversionUnit={values.items[index].product ? values.items[index].product.conversionUnit : undefined}
                          disabled
                          // max={values.items[index].quantity}
                          defualtValue={values.items[index].quantity}
                        />
                      }
                      <ErrorMessage component={ErrorPopUp} name={`items[${index}].quantity`} style={{ margin: '0 auto' }} />
                    </td>
                    : ''}
                  {values.unitTaskStatus === 2 ?
                    <td>
                      <div>
                        <QtyInput
                          disabled={values.items[index].product && values.items[index].product.conversionUnit && values.items[index].product.measurementType !== values.items[index].product.subMeasurementType ? true : false}
                          className="text-input"
                          measurementType={values.items[index].product ? values.items[index].product.measurementType : undefined}
                          subMeasurementType={values.items[index].product ? values.items[index].product.subMeasurementType : undefined}
                          conversionUnit={values.items[index].product ? values.items[index].product.conversionUnit : undefined}
                          onChange={(val, subVal) => {

                            // if (subVal) {

                            // if (val <= values.items[index].unitProductQuantity) {
                            setFieldValue(`items[${index}][subWaste]`, subVal)
                            // } else {
                            //   setFieldValue(`items[${index}][subWaste]`, undefined)
                            //   setFieldValue(`items[${index}][waste]`, undefined)
                            // }

                            // } else {
                            //   setFieldValue(`items[${index}][subWaste]`, undefined)
                            // }

                            setFieldValue(`items[${index}][waste]`, val)

                          }}
                          // max={values.items[index].quantity}
                          value={values.items[index].waste}
                        />
                        <ErrorMessage component={ErrorPopUp} name={`items[${index}].waste`} style={{ margin: '0 auto' }} />
                      </div>
                    </td>
                    : ''}
                  {/* <td>
                    {values.items[index].product ? measurementTypes.filter(el => el.value === values.items[index].product.measurementType)[0].label : ''}
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </fieldset>
      </div>
    </div>

    {values.lastDescription ?
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <fieldset className="fieldset">
            <legend>توضیحات مدیر واحد کلیک</legend>
            <pre className="pre">{values.lastDescription}</pre>
          </fieldset>
        </div>
      </div>
      : ''}
  </>
);